import {invisiblyApi} from "../api/invisibly-api";
import {SurveyMediaPlan, SurveyMediaPlanJSON} from "./media-plan.types";
import {InvisiblyApiResponse} from "../../services/api/api-response.types";
import SurveyService from "../../services/surveys/survey.service";
import {surveyEndpoints} from "./survey.endpoints";
import { createShare } from "../../services/surveys/surveys.helpers";
import { APITagType } from "../api/invisibly-api.types";

const mediaPlanEndpoints = invisiblyApi.injectEndpoints({
  endpoints: (builder) => ({
    createMediaPlan: builder.mutation<SurveyMediaPlan, { ext_survey_id: string }>({
      query: ({ ext_survey_id }) => ({
        data: {ext_survey_id},
        method: 'post',
        url: 'b2b/media-plan',
      }),
      transformResponse: (response: InvisiblyApiResponse<SurveyMediaPlanJSON>) => {
        return SurveyService.parseMediaPlan(response.item);
      },
      async onQueryStarted({ ext_survey_id }, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (!data) {
            return;
          }

          dispatch(surveyEndpoints.util.updateQueryData('getSurvey', { ext_survey_id }, (draft) => {
            const patch = draft;
            draft.extMediaPlanId = data.extMediaPlanId;
            Object.assign(patch, draft);
          }));
        } catch (error) {
          console.error('Error creating media plan', error);
        }
      },
    }),
    getMediaPlan: builder.query<SurveyMediaPlan, { ext_survey_id: string, share?: boolean }>({
      query: ({ ext_survey_id, share }) => ({
        method: 'get',
        params: share === true ? undefined : { use_ext_survey_id: true },
        url: createShare(`b2b/media-plan/${ext_survey_id}`, share, 'b2b'),
        handleErrorGlobally: false,
      }),
      providesTags: [APITagType.MediaPlan],
      transformResponse: (response: InvisiblyApiResponse<SurveyMediaPlanJSON>) => {
        return SurveyService.parseMediaPlan(response.item);
      },
      async onCacheEntryAdded(
        { ext_survey_id },
        { cacheDataLoaded, cacheEntryRemoved, updateCachedData }
      ) {

        try {
          await cacheDataLoaded;
        } catch (error) {
          console.error('Error fetching media plan', error);
        }
        // Cleanup when the cache subscription is no longer active
        await cacheEntryRemoved;
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useCreateMediaPlanMutation, useGetMediaPlanQuery,
} = mediaPlanEndpoints;
